











































































import { snakeCase } from 'lodash'
import { Component, Mixins, Prop, VModel, Watch } from 'vue-property-decorator'

import ModelSetter from '../../../Mixins/ModelSetter'
import { UseFields } from '../../Pi'
import CashRegisterEditorMixin from './CashRegisterEditorMixin'
import CloudpaymentsSettings from "./CashRegistersSettings/CloudpaymentsSettings.vue";
import CoinbaseSetting from './CashRegistersSettings/CoinbaseSetting.vue'
import CryptobotSetting from './CashRegistersSettings/CryptobotSetting.vue'
import CryptocloudSetting from './CashRegistersSettings/CryptocloudSetting.vue'
import NowpaymentsSetting from './CashRegistersSettings/NowpaymentsSetting.vue'
import PayboxMoneySetting from './CashRegistersSettings/PayboxMoneySetting.vue'
import PaypalSetting from './CashRegistersSettings/PaypalSetting.vue'
import ProdamusSetting from './CashRegistersSettings/ProdamusSetting.vue'
import RobokassaSetting from './CashRegistersSettings/RobokassaSetting.vue'
import SberbankBusinessSetting from './CashRegistersSettings/SberbankBusinessSetting.vue'
import StripeSetting from './CashRegistersSettings/StripeSetting.vue'
import TelegramSetting from './CashRegistersSettings/TelegramSetting.vue'
import UnitpaySetting from './CashRegistersSettings/UnitpaySetting.vue'
import WalletPayProviderSetting from './CashRegistersSettings/WalletPayProviderSetting.vue'
import YookassaSetting from './CashRegistersSettings/YookassaSetting.vue'
import YoomoneySetting from './CashRegistersSettings/YoomoneySetting.vue'
import { XTR_CURRENCY } from "./constants";
import { CashRegisterDataType, CashRegisterType } from './types'

@Component({
  components: {
    CloudpaymentsSettings,
    TelegramSetting,
    CoinbaseSetting,
    PayboxMoneySetting,
    PaypalSetting,
    ProdamusSetting,
    RobokassaSetting,
    SberbankBusinessSetting,
    UnitpaySetting,
    WalletPayProviderSetting,
    YookassaSetting,
    YoomoneySetting,
    CryptobotSetting,
    CryptocloudSetting,
    NowpaymentsSetting,
    StripeSetting,
  },
  data() {
    return {
      CashRegisterType,
      XTR_CURRENCY
    }
  },
  methods: {
    snakeCase
  }
})
export default class CashRegisterDataSettings extends Mixins<UseFields, ModelSetter, CashRegisterEditorMixin>(UseFields, ModelSetter, CashRegisterEditorMixin) {
  @VModel() data!: CashRegisterDataType

  @Prop() type!: CashRegisterType

  @Prop() currency!: string

  @Watch('type')
  typeWatcher(type: CashRegisterType): void {
    this.data = this.getCashRegisterDataByType(type)
  }

  get fields(): Array<string> {
    return Object.keys(this.data)
  }
}
